import styled from 'styled-components'

export const Name = styled('h4')`
  font-size: 1em;
  font-weight: bold;
  color: ${(props) => props.theme.colors.black};
  margin: 0;
`

export const JobTitle = styled('div')``

export const Qoute = styled('blockquote')`
  position: relative;
  margin: 0;
  margin-top: 18px;
  padding-left: 15.2px;
  font-style: italic;
  border-left: 2px solid ${(props) => props.theme.colors.blue};

  &::before {
    content: '“';
    padding-right: 2px;
    margin-left: -2px;
  }

  &::after {
    content: '”';
    padding-left: 2px;
    margin-right: -2px;
  }
`

export const Email = styled('a')`
  display: block;
  color: ${(props) => props.theme.colors.blue};
  text-decoration: none;
  line-height: 1.2;
`
